<nav
  main-navigation
  class="attendee-navigation-header w-full h-6 order-1 lg:w-auto lg:h-full lg:order-none"
>
  <ul
    class="flex h-full items-center text-center text-sm font-medium border-b border-grey-light-1 lg:border-none"
  >
    <ng-container *ngFor="let link of links; let isFirst = first">
      <li
        class="relative flex w-1/2 h-full lg:w-auto"
        [class.lg:ml-6]="!isFirst"
      >
        <a
          *ngIf="link.is_external_link"
          class="m-auto"
          [href]="link.url"
          target="_blank"
          rel="noreferrer noopener"
        >
          {{ link.text }}
        </a>

        <a
          *ngIf="!link.is_external_link"
          #rla="routerLinkActive"
          class="m-auto"
          [routerLink]="link.url"
          routerLinkActive="header__navigation__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.aria-current]="rla.isActive && 'page'"
        >
          {{ link.text }}
        </a>
      </li>
    </ng-container>
  </ul>
</nav>
